import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { deleteEmaQuestionnaire } from './emaQuestionnaire.api';

export const useDeleteEmaQuestionnaire = () => {
  const queryClient = useQueryClient();
  const { open } = useNotification();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteEmaQuestionnaire,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ema-questionnaire'] });
      open?.({
        type: 'success',
        message: t('pages.studies.emaQuestionnaire.delete.success'),
      });
    },
    onError: () => {
      open?.({
        type: 'error',
        message: t('pages.studies.emaQuestionnaire.delete.error'),
      });
    },
  });
};
